module.exports = __webpack_public_path__ + "img/iconlist-1.338ff676.png";